import api from "./api";

// One canvas per conversation (channelId or sorted DM composite). The `api`
// response interceptor returns response.data, so each call resolves to
// `{ success, data: canvas }` where canvas = { conversationId, chatType, blocks }.

export function getCanvas(conversationId) {
  return api.get(`/canvas/${encodeURIComponent(conversationId)}`);
}

export function addCanvasBlock(conversationId, content, chatType) {
  return api.post(`/canvas/${encodeURIComponent(conversationId)}/blocks`, {
    content,
    chatType,
  });
}

export function updateCanvasBlock(conversationId, blockId, content) {
  return api.put(
    `/canvas/${encodeURIComponent(conversationId)}/blocks/${blockId}`,
    { content },
  );
}

export function deleteCanvasBlock(conversationId, blockId) {
  return api.delete(
    `/canvas/${encodeURIComponent(conversationId)}/blocks/${blockId}`,
  );
}
